import React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';
import { getToken, isAuthenticated } from '../../store/auth';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Return, Select } from '../inspinia'
import CodeMirror from '../codeMirror';
import TagSelectorHTML from '../tagSelectorHTML';
import ModalPreview from './modalPreview'
import ModalSendTest from './modalSendTest'
import TemplateSelector from '../templateSelector';
import FileUpload from './fileUpload';
import RichTextEditor from '../richtext';
import {EMAIL} from '../../store/tipoListaEmail';


class NovaEditorHtml extends React.PureComponent {
    constructor(props) {
        super(props);

        const initialForm = this.formInitialState();

        const empresaDaUrl = props.location.state?.empresa;
        if (empresaDaUrl) {
        initialForm.empresa = empresaDaUrl;
        }


        this.state =
        {
            loading: false,
            form: initialForm,
            modalPreviewIsOpen: false,
            modalSendTestIsOpen: false,

            //Utilizado para recuperar as informações o ID da Campanha
            idCampanha: this.props.campanha.idCampanha,
            emailUsuario: this.props.auth.user.email,
            usuario: {},
            auth: this.props.auth,
            posicaomouse1: [],
            posicaomouse2: [],
            tipoSalvar: "", 
            templateAntigo: "",
            templates: [],

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handleChangeText = this.handleChangeText.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeAssunto = this.handleChangeAssunto.bind(this);
        this.handlePreviewToggle = this.handlePreviewToggle.bind(this);
        this.handleTestToggle = this.handleTestToggle.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.insereTemplate = this.insereTemplate.bind(this);

        this.state.usuario['email'] = this.state.emailUsuario;

    }

    formInitialState() {

        return {

            id: "",
            template: [],
            nomeTemplateHtml: "",
            file: "",
            empresa: {},
            nome: "",
            mensagem: "",
            assunto: "",
            url: ""

        }
        
    }

    componentDidMount() {

        const empresa = this.props.location.state?.empresa;
        if (empresa) {
            this.setState(prev => ({
                form: {
                    ...prev.form,
                    empresa: empresa
                }
            }));
        }
        
        this.RecuperarTemplates();
        this.RecuperarIdCampanhaEditar();

        

    }

    insereTemplate(states, id) {
        const url = `${c.API_CAMPAIGN_URL}/template/${id}`;
        const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

        callApi(url, options, (response) => {
            this.setState(prev => ({
                form: {
                    ...prev.form,
                    id: response.id,
                    nome: response.nome,
                    mensagem: response.mensagem,
                    assunto: response.assunto,
                    file: response.idArquivo,
                    url: response.url,
                }
            }));
            this.props.actions.campanha.setArquivoTemplate(
                response.idArquivo ? { idArquivoTemplate: response.idArquivo } : null
            );
        });
    }

    RecuperarTemplates() {
        const empresa = this.state.form.empresa.id;
        const url = `${c.API_CAMPAIGN_URL}/template-usuario/${empresa}?page=0&size=1000`;
        const options = this.state.optionsGet;

        callApi(url, options, (response) => {
            this.setState({ templates: response.content || [] });
        });
    }

    RecuperarIdCampanhaEditar() {
        const idCampanha = this.state.idCampanha;
        const url = `${c.API_CAMPAIGN_URL}/template-campanha/${idCampanha}`;
        callApi(url, this.state.optionsGet, (response) => {
            this.setState(({ form }) => ({
                form: {
                    ...form,
                    id: response.id,
                    nome: response.nome,
                    mensagem: response.mensagem,
                    assunto: response.assunto,
                    file: response.idArquivo,  
                    url: response.url
                }
            }));
            this.props.actions.campanha.setArquivoTemplate(
                       response.idArquivo ? { idArquivoTemplate: response.idArquivo } : null
                     );
        });
    }

    handlePreviewToggle(e) {
        this.setState({ ...this.state, modalPreviewIsOpen: !this.state.modalPreviewIsOpen });
    }

    handleTestToggle(e) {
        this.setState({ ...this.state, modalSendTestIsOpen: !this.state.modalSendTestIsOpen });
    }

    handleSave(e) {
        e.preventDefault(); if (this.state.loading) return;

        let self = this;

        this.setState({ tipoSalvar: e.target.name });
        this.state.form.auth = this.state.auth;
        let idCampanha = this.state.idCampanha;
        let editor = 'html';

        let idArquivoTemplate = '';

        let tipoTemplate = EMAIL;

        if (this.props.campanha.arquivoTemplate !== undefined) {
            idArquivoTemplate = this.props.campanha.arquivoTemplate?.idArquivoTemplate || '';
        }
        
        
        this.props.actions.campanha.salvarTemplate(this.state.form, idCampanha, editor, idArquivoTemplate,tipoTemplate).then((response) => {
            if (response.status === "BAD_REQUEST") {
                c.TOASTER_SUCCESS(response.message);
                return;
            }

            if (response) {
                c.TOASTER_SUCCESS("Template salvo com sucesso!");

                if (self.state.tipoSalvar !== "salvarcontinuar") {
                    c.TOASTER_SUCCESS("Campanha salva com sucesso!");
                    self.props.history.push(c.PANEL_ROUTE);

                } else if (self.state.tipoSalvar === "salvarcontinuar") {
                    self.props.campanha.template = self.state.form.mensagem;
                    self.props.history.push(c.CAMPAIGN_ROUTE + "/nova/checklist");

                }
            }

        }).catch((error) => {
            if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
        });
    }

    inserTag(campo) {
        var element = document.getElementById("summernote");
        element.value = element.value.substring(0, this.state.posicaomouse1)
            + campo.target.innerText
            + element.value.substring(this.state.posicaomouse2, element.value.length);
        this.state.form.mensagem = element.value;
    }

    handleChangeText(content) {
        const texto = content.replace("tagselectorhtml:", "");
        this.setState(prev => ({
            form: { ...prev.form, mensagem: texto }
        }));
    }

    handleChangeName(e) {
        const nome = e.target.value;
        this.setState(prev => ({
          form: {
            ...prev.form,
            nome
          }
        }));
      }

      handleChangeAssunto(e) {
        const assunto = e.target.value;
        this.setState(prev => ({
          form: {
            ...prev.form,
            assunto
          }
        }));
      }

      handleChangeTextHtml(texto) {
        const mensagem = texto.replace("tagselectorhtml:", "");
        this.setState(prev => ({
          form: {
            ...prev.form,
            mensagem
          },
          posicaomouse1: 0,
          posicaomouse2: 0
        }));
      }

    onChangeFile(e) 
    {
        const form = this.state.form;
        
        form.file = e.target.files[0];        

        this.setState({file:e.target.files[0]});

        if(this.state.form.file !== '') {
 
            if (!isAuthenticated()) {
                throw (c.MESSAGE_ERROR(c.AUTH_ERROR));
            }

            this.props.actions.campanha.setArquivoTemplate(null);

            const _token = c.AUTH_HEADER(getToken());

            let data = new FormData();
            data.append('file', form.file);

            const url = `${ c.API_CAMPAIGN_URL }/uploadFileHtml`;
            const config = {
                headers: {
                    'content-type': 'multipart/form-data', 
                    'Authorization': _token
                }
            };
            const options = {
                method: 'POST',
                body: data,
                headers: {'Authorization': _token }
            };

            fetch(url, options).then(async(response) => {            
                let json = await response.json();

                if (response.ok) {  
                    this.handleChangeTextHtml(json.html);

                } else {
                    c.TOASTER_ERROR(json.message);        

                }
                    
            }).catch((exception) => {
                console.log("fetch error" + exception);
            });

        }

    }

    render() {
        const form = this.state.form;

        return (
            <div>
                <ModalPreview isOpen={this.state.modalPreviewIsOpen} toggle={this.handlePreviewToggle} preview={form.mensagem} />
                <ModalSendTest isOpen={this.state.modalSendTestIsOpen} toggle={this.handleTestToggle} />

                {/* TITLE */}
                <Row className="mb-4">
                    <Column size="3">
                        <h2 className="fs-20 fw-600 text-body m-0">Editor HTML</h2>
                    </Column>

                    <Column size="9">
                        <div className="input-group d-block fs-14 text-right">
                            <button type="button" onClick={this.handlePreviewToggle} className="btn btn-link px-3">Pré-visualizar</button>                                                        

                            <button name="salvar" type="button" onClick={this.handleSave} className="btn btn-link px-3">Salvar</button>

                            <button name="salvarcontinuar" type="button" onClick={this.handleSave} className="btn btn-primary px-4">Salvar e avançar <Icon name="fa-chevron-right" className="ml-2" /></button>
                        </div>
                    </Column>
                </Row>

                {/* FORM */}
                <Row className="mb-3">
                    <Column size="9">
                        <IBox className="mb-0">
                            <div>
                                <label>Nome do Template</label>
                            </div>
                            <div>
                                <input onChange={this.handleChangeName} value={this.state.form.nome}></input>
                            </div>
                            <div className='mt-3'>
                                <label>Selecione o Arquivo HTML</label>
                            </div>
                            <div>
                                <input type="file" name="file"                                      
                                    id="validatedCustomFile" 
                                    required 
                                    value={this.state.arquivo} 
                                    onChange={this.onChangeFile}
                                    onClick={(event)=> event.target.value = null}
                                />
                                
                            </div>


                            <label className='mt-3'>Corpo do Template</label>

                            {/* Editor here */}
                            <RichTextEditor value={this.state.form.mensagem} onChange={this.handleChangeText} key={this.state.form.id || 'novo'} />


                        </IBox>
                    </Column>

                    <Column size="3" className="container">
                        <Row>
                            <Column size="12" className="py-3">

                                <TemplateSelector status={this.state} templates={this.state.templates} onClick={this.insereTemplate.bind(this)}/>

                            </Column>
                        </Row>

                        <Row>
                            <Column size="12" className="py-3">

                                <TagSelectorHTML status={this.state} getCampanha={this.state.idCampanha} />

                            </Column>
                        </Row>

                        <Row>
                            <Column size="12">
                                <FileUpload status={this.state} idTemplate={this.state.form.id} />
                            </Column>
                        </Row>
                    </Column>
                </Row>


                {/* GO BACK */}
                <Row className="mb-5">
                    <Column size="12" className="mx-auto container">
                        <div className="d-flex justify-content-start">

                            <Return to={this.props.campanha.urlRetorno} width="130px" />

                        </div>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, campanha: state.campanha };
}
function mapDispatchToProps(dispatch) {
    return { actions: { campanha: bindActionCreators(campanhaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NovaEditorHtml));
